import { render, staticRenderFns } from "./Index_copy.vue?vue&type=template&id=c3e5b2d8&scoped=true&"
import script from "./Index_copy.vue?vue&type=script&lang=js&"
export * from "./Index_copy.vue?vue&type=script&lang=js&"
import style0 from "./Index_copy.vue?vue&type=style&index=0&id=c3e5b2d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e5b2d8",
  null
  
)

component.options.__file = "Index_copy.vue"
export default component.exports